import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthInterceptor } from './auth.interceptors';
import { HttpBackendClient, HttpClientService } from './http.service';


export class PlannerHttpClientModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    HttpClientModule
  ],
  providers: [
    HttpClientService,
    HttpBackendClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
